const styles = {
  radio: {
    flex: 1,
  },
  select: {
    size: 'small',
    MenuProps: { PaperProps: { sx: { maxHeight: 400 } } },
  },
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: '#fff',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
  circle: {
    borderRadius: '50%',
    width: 40,
    height: 40,
    minWidth: 40,
    p: 0,
    color: 'text.primary',
    '&.Mui-selected': {
      bgcolor: 'primary.main',
      color: 'white',
      '&:hover': {
        bgcolor: 'primary.dark',
      },
    },
  },
  textDisabled: {
    color: 'text.disabled',
  },
};

export default styles;
